import ShowLocationMap from 'components/UI/Map/showLocationModal/ShowLocationMap';
import TcMap from 'components/UI/Map/TcMap';
import TcModal from 'components/UI/Modal/TcModal';
import TcShowInfo from 'components/UI/ShowInfo/TcShowInfo';
import { useEffect, useState } from 'react';

const TcShowLocationModal = ({ location, close }) => {
  //states
  const [showMap, setShowMap] = useState(false);

  //effect
  useEffect(() => {
    location &&
      setTimeout(() => {
        setShowMap(true);
      }, 1000);
    !location && setShowMap(false);
  }, [location, showMap]);

  const latlng = location?.lat && location?.lng && [location?.lat, location?.lng];

  if (!latlng) return null;
  return (
    <TcModal visible={location} onCancel={close} title='موقعیت مکانی' footer={false}>
      {latlng && (
        <>
          <TcShowInfo right='عرض Latitude' left={latlng[0]} />
          <TcShowInfo right='طول Longitude' left={latlng[1]} />

          {showMap && (
            <TcMap customHeight='h-80 w-full' customKey={latlng[0] + latlng[1]}>
              <ShowLocationMap location={latlng} />
            </TcMap>
          )}
        </>
      )}
    </TcModal>
  );
};

export default TcShowLocationModal;
